<template>
  <div v-loading="loading"
       element-loading-text="拼命加载中">
    <el-form class="search-box" ref="form" :model="form" :rules="rules">
      <el-form-item prop="order_number">
        <el-input
          ref="search"
          @focus="stopKeyborad"
          @blur="stopKeyborad"
          v-model="form.order_number"
          @keydown.enter.native.prevent="onSubmit"
          placeholder="扫描包裹号"
        >
          <el-button
            @click.prevent="onSubmit"
            slot="append"
            icon="el-icon-search"
          ></el-button>
        </el-input>
      </el-form-item>
    </el-form>

    <div v-if="items.length>0">

      <div>
        <span style="font-weight: bold">包裹号: </span>{{ items[0].order_number }}
      </div>
      <!--<div><span style="font-weight: bold">交易编号: </span>{{ items[0].transaction_no }}</div>-->

    </div>

    <template v-for="item of items">
      <div class="show" :key="item.id" @click="select(item)">
        <div class="line">


          <el-row :gutter="10">
            <el-col :span="16">
              <el-row>
                <!--<el-col :span="24">-->
                <!--  <div class="grid-content bg-purple-light" style="color: #3967FF">-->
                <!--    <p>采购单号: {{ item.purchase.purchase_no }}</p>-->
                <!--  </div>-->
                <!--</el-col>-->
                <el-col :span="24">
                  <div class="grid-content bg-purple"
                       style="color: #bd2c00">
                    <h3>订单编号</h3>
                    <p>{{ item.transaction_number }}</p>
                  </div>
                </el-col>
                <el-col :span="24">
                  <div class="grid-content bg-purple-light">
                    <!--<h3>数量</h3>-->
                    <!--<p style="color:  #bd2c00">{{ item.quantity }}</p>-->
                    <p><span style="font-weight: bold">数量</span>: <span style="color: #bd2c00">{{
                        item.quantity
                      }}</span></p>
                  </div>
                </el-col>
                <!--            <el-col :span="12">
                              <div class="grid-content bg-purple-light">
                                <h3>SKU</h3>
                                <p>{{ item.sku }}</p>
                              </div>
                            </el-col>-->
                <!--            <el-col :span="12">
                              <div class="grid-content bg-purple-light">
                                <h3>商品中文名称</h3>
                                <p>{{ item.product_name }}</p>
                              </div>
                            </el-col>-->
                <el-col :span="24" v-if="item.word!==null">
                  <div class="grid-content bg-purple-light">
                    <p><span style="font-weight: bold">定制文案</span>: <span style="color: red">{{ item.word }}</span></p>
                  </div>
                </el-col>
                <el-col :span="24" v-if="item.remark!==null">
                  <div class="grid-content bg-purple-light">
                    <p>备注: {{ item.remark }}</p>
                  </div>
                </el-col>
                <el-col :span="24" v-if="item.shelf_id!==null">
                  <div class="grid-content bg-purple-light" style="color: #3967FF">
                    <p>货架号: {{ item.shelf.shelf_no }}</p>
                  </div>
                </el-col>

                <template v-else>
                  <el-col :span="24" v-if="item.history_shelf_id!==null">
                    <div class="grid-content bg-purple-light" style="color: #3967FF">
                      <p>历史货架号: {{ item.history_shelf.shelf_no }}</p>
                    </div>
                  </el-col>
                </template>

                <el-col :span="24">
                  <div class="grid-content bg-purple-light">
                    <p v-if="item.status===0">状态: <span style="color: #9a6e3a">未验收</span></p>
                    <p v-else-if="item.status===1">状态: <span style="color: #55a532">完成</span></p>
                    <p v-else-if="item.status===2">状态: <span style="color: red">异常</span></p>
                    <p v-else-if="item.status===3">状态: <span style="color: #3a8ee6">已拣货</span></p>
                    <p v-else>状态: 其它</p>
                  </div>
                </el-col>
                <el-col :span="24" v-if="item.accept_at">
                  <div class="grid-content bg-purple-light">
                    <p>时间: {{ item.accept_at }} </p>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <img :src="item.image_url" alt="" width="100%">
            </el-col>
          </el-row>

        </div>
      </div>
    </template>
    <!--<div style="margin-top: 20px;text-align: center" :hidden="!items.length"> <el-button @click="removeShelf">一键移除货架号</el-button></div>-->

    <el-dialog
      title="提示"
      :visible.sync="centerDialogVisible"
      width="90%"
      top="30vh"
      :close-on-click-modal="false"
      center>
      <span>该订单货已到齐,是否标记为已拣货？</span>
      <span slot="footer" class="dialog-footer">
    <el-button @click="cancelDialog">取 消</el-button>
    <el-button style="margin-left: 50px" type="primary" @click="removeShelf">标记</el-button>
  </span>
    </el-dialog>

  </div>
</template>

<script>
// import {mapState,mapMutations} from 'vuex';
// import Bus from '@/assets/js/bus';
export default {
  name: "B2bCheck",
  data() {
    return {
      centerDialogVisible: false,
      // lock_shelf:"",
      remove_order: '',
      loading: false,
      form: {
        order_number: ""
      },
      rules: {
        order_number: [
          {required: true, message: "请扫描订单编号", trigger: "blur"},
          /*{
            type: "number",
            message: "请输入正确的订单编号",
            trigger: ["blur", "change"],
          },*/
        ],
      },
      items: {},

      bus_item: {}

    }
  },
  methods: {
    // ...mapMutations(['setShelf']),
    select(item) {
      item.lock_shelf = this.lock_shelf
      // item.purchase_no = item.purchase.purchase_no
      item.shelf_off = this.shelf_off

      this.bus_item = item
      // this.$EventBus.$emit('order', item);
      this.$router.push({
        path: '/b2b-detail',
        // query: item
      })

    },
    onSubmit() {

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          this.http.fetchGet(this.api.b2b_product + "/" + this.form.order_number).then((res) => {
            // this.loading = false
            var data = res.data;
            console.log(data)
            if (data.code === 200) {
              // let lists = data.data;
              this.items = data.data;
              this.remove_order = this.form.order_number
              this.form.order_number = ""
              this.onfocusEvent()

              //更改地址参数
              const query=JSON.parse(JSON.stringify(this.$route.query))
              query.order_number=this.items[0].order_number
              this.$router.push({ path: this.$route.path, query })

              if (this.items.length === 1) {
                this.select(this.items[0])
              } else {
                this.openDialog()
              }

            } else {
              this.$message.error(data.message);
              this.form.order_number = ""
              this.onfocusEvent()
            }

            this.loading = false
            // 请求成功处理
          }).catch((err) => {
            console.log(err);
            this.form.order_number = ""
            this.onfocusEvent()
            this.$message.error('扫描订单号错误');
            this.loading = false
          });
        } else {
          // this.$message.error('请输入账号和密码');
          console.log("error submit!!");
          return false;
        }
      });

    },

    //更新列表数据
    refresh(number) {
      this.http.fetchGet(this.api.b2b_product + "/" + number).then((res) => {
        // this.loading = false
        var data = res.data;
        console.log(data)
        if (data.code === 200) {
          // let lists = data.data;
          // console.log(shops);
          this.remove_order = number
          this.items = data.data;
          this.form.order_number = ""
          this.onfocusEvent()
          if (this.items.length > 1) {
            //提示标记发货弹窗
            this.openDialog()
          }

        } else {
          this.$message.error(data.message);
          this.form.order_number = ""
          this.onfocusEvent()
        }

        // this.loading = false
        // 请求成功处理
      }).catch((err) => {
        console.log(err);
        this.form.order_number = ""
        this.onfocusEvent()
        // this.loading = false
      });
    },

    openDialog() {
      //提示标记发货弹窗
      let open = true;
      for (let i = 0; i < this.items.length; i++) {
        console.log(this.items[i])
        if (this.items[i].status !== 1) {
          open = false;
          break;
        }
      }

      if (open) {
        this.centerDialogVisible = true
      }
    },

    cancelDialog() {
      this.centerDialogVisible = false
      this.onfocusEvent()
    },

    //自动获取光标
    onfocusEvent() {
      this.$refs.search.focus()
    },
    stopKeyborad(e) {
      //尝试一下
      e.target.setAttribute('readonly', true);
      setTimeout(() => {
        e.target.removeAttribute('readonly');
      }, 100);
    },
    removeShelf() {
      this.centerDialogVisible = false
      this.loading = true
      this.http.fetchDel(this.api.removeB2bShelf + "/" + this.remove_order).then((res) => {
        var data = res.data
        if (data.code === 200) {
          this.$message.success("标记已拣货成功")
          this.refresh(this.remove_order)
          this.loading = false
        }
      }).catch(err => {
        console.log(err)
      })
    }
  },
  computed: {
    lock_shelf() {
      for (let item of this.items) {
        if (item.shelf_id != null) {
          return item.shelf_id
        }
      }
      return null
    },
    shelf_off() {
      if (this.items.length === 1) {
        return 1;
      } else {
        return 0;
      }

    }
  },
  /*watch: {
    $route: { // 监听路由的参数变化
      handler() { // 数据变化更新数据
        var instId = this.$route.query.order_number
        if (instId !== undefined) {
          this.refresh(instId)
        }
      },
      immediate: true // 立即执行
    }
  },*/

  /*beforeDestroy() {
    this.$EventBus.$emit('order', this.bus_item);
  },*/

  //被 keep-alive 缓存的组件失活时调用
  deactivated(){
    this.$EventBus.$emit('order', this.bus_item);
  },

  //被 keep-alive 缓存的组件激活时调用
  activated(){
    // console.log(23456)
    this.onfocusEvent()

    var instId = this.$route.query.order_number
    if (instId !== undefined) {
      this.refresh(instId)
    }

  },

  /*mounted() {
    // alert(123)
    this.onfocusEvent()
  }*/

}
</script>

<style scoped lang="stylus">

.show {
  //float: left;
  width: 100%;

  .line {
    box-sizing: border-box;
    border: 1px solid black;
    //margin-top: 1rem;
    margin: 1px;
    //float: left;
    width: 100%;

    .el-col {
      margin-top 5px
      margin-bottom: 5px;
      padding 0 5px

      &:last-child {
        //margin-bottom: 0;
      }
    }

    .grid-content {
      //text-align center

      h3 {
        font-size 14px
      }
    }

  }
}


@media (max-width: 720px) {


}

</style>
